/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OWEvent } from './OWEvent';
import {
    OWEventFromJSON,
    OWEventFromJSONTyped,
    OWEventToJSON,
    OWEventToJSONTyped,
} from './OWEvent';

/**
 * 
 * @export
 * @interface CreateOWLogRequestBody
 */
export interface CreateOWLogRequestBody {
    /**
     * Array can contain a single OWEvent (time-based) or multiple OWEvent (event-based).
     * @type {Array<OWEvent>}
     * @memberof CreateOWLogRequestBody
     */
    events: Array<OWEvent>;
    /**
     * The source of the data (OVERWOLF_ELECTRON or OVERWOLF).
     * @type {string}
     * @memberof CreateOWLogRequestBody
     */
    source?: CreateOWLogRequestBodySourceEnum;
    /**
     * The category of the log event (EVENT or TIME).
     * @type {string}
     * @memberof CreateOWLogRequestBody
     */
    category: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOWLogRequestBody
     */
    pkgVersion?: string;
    /**
     * The PartnerService _id issued to this partner integration (NOT a cryptographic key).
     * @type {string}
     * @memberof CreateOWLogRequestBody
     */
    publicKey?: string;
}


/**
 * @export
 */
export const CreateOWLogRequestBodySourceEnum = {
    OVERWOLF_ELECTRON: 'OVERWOLF_ELECTRON',
    OVERWOLF: 'OVERWOLF'
} as const;
export type CreateOWLogRequestBodySourceEnum = typeof CreateOWLogRequestBodySourceEnum[keyof typeof CreateOWLogRequestBodySourceEnum];


/**
 * Check if a given object implements the CreateOWLogRequestBody interface.
 */
export function instanceOfCreateOWLogRequestBody(value: object): value is CreateOWLogRequestBody {
    if (!('events' in value) || value['events'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    return true;
}

export function CreateOWLogRequestBodyFromJSON(json: any): CreateOWLogRequestBody {
    return CreateOWLogRequestBodyFromJSONTyped(json, false);
}

export function CreateOWLogRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOWLogRequestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'events': ((json['events'] as Array<any>).map(OWEventFromJSON)),
        'source': json['source'] == null ? undefined : json['source'],
        'category': json['category'],
        'pkgVersion': json['pkgVersion'] == null ? undefined : json['pkgVersion'],
        'publicKey': json['publicKey'] == null ? undefined : json['publicKey'],
    };
}

export function CreateOWLogRequestBodyToJSON(json: any): CreateOWLogRequestBody {
    return CreateOWLogRequestBodyToJSONTyped(json, false);
}

export function CreateOWLogRequestBodyToJSONTyped(value?: CreateOWLogRequestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'events': ((value['events'] as Array<any>).map(OWEventToJSON)),
        'source': value['source'],
        'category': value['category'],
        'pkgVersion': value['pkgVersion'],
        'publicKey': value['publicKey'],
    };
}

